import {
    POPUP_KEY_CREATE_INGREDIENT,
    PRODUCT_FORM_LIQUID,
    RECIPE_INGREDIENT_GROUP_LIQUID,
    RECIPE_INGREDIENT_TYPE_PRODUCT,
} from "../constant";
import i18n from "../i18nService";
import { productsService } from "./productsService";
import { productsStorage } from "./productsStorage";

const hasFormGroup = (product, formGroup) => (
    Array.isArray(product.productForms)
    && product.productForms.some((form) => form.formGroup === formGroup)
);

const transformProductsList = (products, i18nInstance = i18n) => {
    return products.map(it => {
        return {
            itemId: it.id,
            itemTitle: productsService.getLocalization(i18nInstance.resolvedLanguage, it.productCode, true, i18nInstance),
            included: true,
            code: it.productCode,
        };
    });
};

const filterProductsForIngredientGroup = (products, ingredientGroup) => {
    if (ingredientGroup !== RECIPE_INGREDIENT_GROUP_LIQUID) {
        return products;
    }
    const liquids = products.filter((product) => (
        !product.isDeleted && hasFormGroup(product, PRODUCT_FORM_LIQUID)
    ));
    return liquids.slice().sort((a, b) => {
        if (a.productCode === 'water') {
            return -1;
        }
        if (b.productCode === 'water') {
            return 1;
        }
        const nameA = productsService.getLocalization(i18n.resolvedLanguage, a.productCode, true) || a.productCode;
        const nameB = productsService.getLocalization(i18n.resolvedLanguage, b.productCode, true) || b.productCode;
        return String(nameA).localeCompare(String(nameB), i18n.resolvedLanguage);
    });
};

export const recipeAddIngredientService = {
    observersList: [],
    filter: '',
    selectedProducts: [],
    ingredientType: RECIPE_INGREDIENT_TYPE_PRODUCT,
    ingredientGroup: '',

    notifyItemsChangingObservers() {
        this.observersList.forEach(observer => observer());
    },
    setIngredientGroup(ingredientGroup) {
        this.ingredientGroup = ingredientGroup || '';
        this.notifyItemsChangingObservers();
    },
    getPossibleItems() {
        const products = filterProductsForIngredientGroup(
            productsStorage.getItems(true),
            this.ingredientGroup,
        );
        return transformProductsList(products)
            .filter(it => it.itemTitle.toLowerCase().includes(this.filter.toLowerCase()));
    },
    getCurrentItems() {
        return this.selectedProducts;
    },
    getPlaceHolder() {
        return "";
    },
    deleteItem(productId, deleteAll) {
        this.selectedProducts = deleteAll ? [] : this.selectedProducts.filter(it => it.itemId !== productId);
        this.notifyItemsChangingObservers();
    },
    addItem(productId, i18nInstance = i18n) {
        const currentProduct = productsStorage.getById(productId);
        this.selectedProducts.push({itemId: currentProduct.id, code: currentProduct.productCode,
            itemTitle: productsService.getLocalization(i18nInstance.resolvedLanguage, currentProduct.productCode, true, i18nInstance),
            included: true});
        this.setSearchFilterValue('');
        this.notifyItemsChangingObservers();
    },
    registerItemsChangingObserver(observer) {
        this.observersList.push(observer);
    },
    unRegisterItemsChangingObserver(observer) {
        try {
            this.observersList = this.observersList.filter(observerItem => observerItem !== observer);
        } catch (err) {
            console.log(err);
        }
    },
    hasExcludedItemsBlock() {
        return false;
    },
    setSearchFilterValue(searchValue) {
        this.filter = searchValue;
        this.notifyItemsChangingObservers();
    },
    getSearchString() {
        return this.filter;
    },
    isSearchStringChanged() {
        return true;
    },
    handleSearchFilterValue() {},
    getPopupKey() {
        return POPUP_KEY_CREATE_INGREDIENT;
    },
    getButtonTitle(i18nInstance = i18n) {
        return i18nInstance.t('app.page.recipe.addProduct');
    },
    getIngredientType() {
        return this.ingredientType;
    },
    changeIngredientType(value) {
        this.ingredientType = value;
        this.selectedProducts = [];
        this.notifyItemsChangingObservers();
    },
    loadItems() {
        return;
    },
};
